export const COPY_FROM_CONDITION_LABEL = 'Copy from Condition Message';

export const EDIT_CONDITION_FORM_ID = 'edit-condition-form';

export const TITLE_HELPER_TEXT =
  'Visible internally and to the partner or borrower as the anchor that replaces "Condition #N".';

export const PARTNER_MESSAGE_HELPER_TEXT =
  'Saved to the condition’s change history; the open date is preserved.';
